<template>
  <div class="modal fade" id="modalChangeDelivery" tabindex="-1" aria-labelledby="modalChangeDeliveryLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="modalChangeDeliveryLabel">{{ $t('orderDeliveryChange.updateDelivery') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="text-center">
            <div class="list-group list-group-horizontal mx-0 mb-3 w-auto">
              <label class="list-group-item w-50 d-flex gap-2">
                <input class="form-check-input flex-shrink-0" type="radio" name="deliveryMethod"
                       v-model="delivery_method"
                       id="deliveryMethodDelivery"
                       value="delivery">
                <span>{{ $t('orderDeliveryChange.delivery') }}</span>
              </label>
              <label class="list-group-item w-50 d-flex gap-2">
                <input class="form-check-input flex-shrink-0" type="radio" name="deliveryMethod"
                       v-model="delivery_method"
                       id="paymentMethodPickup"
                       value="pickup">
                <span>{{ $t('orderDeliveryChange.takeaway') }}</span>
              </label>
            </div>
            <div class="mb-3">
              <input :disabled=" delivery_method === 'pickup' "
                  v-model="delivery_address" type="text" class="form-control" id="deliveryAddress">
            </div>
            <input v-model="commentForChangeDelivery" type="text" class="form-control" id="commentForChangeDelivery" :placeholder="$t('orderDeliveryChange.comment')">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('orderDeliveryChange.cancel') }}</button>
          <button
              @click="updateOrderDelivery()"
              :disabled="emptyComment"
              data-bs-dismiss="modal"
              type="button" class="btn btn-success">{{ $t('orderDeliveryChange.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderDeliveryChange",
  data() {
    return {
      delivery_method: '',
      delivery_address: '',
      commentForChangeDelivery: ''
    }
  },
  computed: {
    emptyComment() {
      if (this.commentForChangeDelivery === '') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    setData(method, address){ //записываем данные
      this.delivery_method = method
      this.delivery_address = address
    },
    updateOrderDelivery() {
      let restId = this.$route.params.id
      let orderId = this.$route.params.orderId
      let requestBody = {
        'delivery_method': this.delivery_method,
        'delivery_address': this.delivery_address,
        'comment': this.commentForChangeDelivery
      }
      if (this.delivery_method === 'pickup') {
        requestBody.delivery_address = '-'
      }
      let payload = { restId, orderId, requestBody }
      this.$store.dispatch('changeMenuItemInOrder', payload)
      this.commentForChangeDelivery = ''
    },
  }
}
</script>

<style scoped>

</style>